export default __webpack_public_path__ + "static/media/giIcon.0d5a3a4a.svg";